import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import SignInPage from "./pages/SignInPage";
import HomePage from "./pages/HomePage";
import PlayPage from "./pages/PlayPage";
import RoomPage from "./pages/RoomPage";
import JoinByCodePage from "./pages/JoinByCodePage";
import OnlinePlayPage from "./pages/OnlinePlayPage";
import StatsPage from "./pages/StatsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import RulesPage from "./pages/RulesPage";
import { BrowserGate } from "./components/BrowserGate";
import Layout from "./components/Layout";

const POST_AUTH_REDIRECT_KEY = "postAuthRedirectPath";

export default function App() {
  return (
    <BrowserGate>
      <AppRoutes />
    </BrowserGate>
  );
}

function AppRoutes() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-felt">
        <div className="text-white/80">Loading…</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route
            path="/"
            element={
              !user
                ? <SignInPage />
                : !profile
                  ? <SignInPage />
                  : <HomePage />
            }
          />
          <Route
            path="/play"
            element={
              !user
                ? <Navigate to="/" replace />
                : !profile
                  ? <Navigate to="/" replace />
                  : <PlayPage />
            }
          />
          <Route
            path="/room/:roomId"
            element={
              !user
                ? <Navigate to="/" replace />
                : !profile
                  ? <Navigate to="/" replace />
                  : <RoomPage />
            }
          />
          <Route
            path="/join/:code"
            element={
              !user
                ? (
                  (() => {
                    sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, window.location.pathname);
                    return <Navigate to="/" replace />;
                  })()
                )
                : !profile
                  ? (
                    (() => {
                      sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, window.location.pathname);
                      return <Navigate to="/" replace />;
                    })()
                  )
                  : <JoinByCodePage />
            }
          />
          <Route
            path="/play-online/:matchId"
            element={
              !user
                ? <Navigate to="/" replace />
                : !profile
                  ? <Navigate to="/" replace />
                  : <OnlinePlayPage />
            }
          />
          <Route
            path="/stats"
            element={
              !user
                ? <Navigate to="/" replace />
                : !profile
                  ? <Navigate to="/" replace />
                  : <StatsPage />
            }
          />
          {import.meta.env.DEV ? (
            <Route path="/stats-demo" element={<StatsPage />} />
          ) : null}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
